import api from '../api';

export const getResultsFormats = async (projectId) => {
  const res = await api.get(`/projects/${projectId}/results-formats`);
  return res.data;
};

export const createResultsFormat = async (projectId, payload) => {
  const res = await api.post(`/projects/${projectId}/results-formats`, payload);
  return res.data;
};

export const getResultsFormatById = async (projectId, resultsFormatId) => {
  const res = await api.get(`/projects/${projectId}/results-formats/${resultsFormatId}`);
  return res.data;
};

export const updateResultsFormat = async (projectId, resultsFormatId, payload) => {
  const res = await api.put(`/projects/${projectId}/results-formats/${resultsFormatId}`, payload);
  return res.data;
};

export const deleteResultsFormat = async (projectId, resultsFormatId) => {
  const res = await api.delete(`/projects/${projectId}/results-formats/${resultsFormatId}`);
  return res.data;
};

export const getResultsFormatCounts = async (projectId, resultsFormatId, filters = {}) => {
  const params = {};

  if (filters.formGroupId) params.formGroupId = filters.formGroupId;

  if (Array.isArray(filters.statuses) && filters.statuses.length > 0) {
    params.statuses = filters.statuses.join(',');
  } else if (typeof filters.statuses === 'string' && filters.statuses.trim()) {
    params.statuses = filters.statuses.trim();
  }

  if (filters.startDate) params.startDate = filters.startDate;
  if (filters.endDate) params.endDate = filters.endDate;

  if (Array.isArray(filters.regionIds) && filters.regionIds.length > 0) {
    params.regionIds = filters.regionIds.join(',');
  } else if (typeof filters.regionIds === 'string' && filters.regionIds.trim()) {
    params.regionIds = filters.regionIds.trim();
  }

  if (Array.isArray(filters.areaIds) && filters.areaIds.length > 0) {
    params.areaIds = filters.areaIds.join(',');
  } else if (typeof filters.areaIds === 'string' && filters.areaIds.trim()) {
    params.areaIds = filters.areaIds.trim();
  }

  const res = await api.get(
    `/projects/${projectId}/results-formats/${resultsFormatId}/counts`,
    { params }
  );

  return res.data;
};
